import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { UtilService } from '../shared/_services/util.service';

@Component({
  selector: 'app-customer-report',
  templateUrl: './customer-report.component.html',
  styleUrls: ['./customer-report.component.scss']
})
export class CustomerReportComponent implements OnInit {
  customerReportList: any; 
  totalRecords: number;
  defaultPageSize : number = 10;
  page: number = 1;
  pageNos: number;
  public loading = false;

  constructor(private http: AuthService, private util : UtilService) { }

  ngOnInit() {
    this.getCustomerReportsData(this.page,this.defaultPageSize);
  }
  // To get Customer report data
  //@@ pageNumer i.e selected page number
  //@@ pageSize  i.e No of results per page
  getCustomerReportsData(pageNumer,pageSize){    
    this.loading = true;
    this.page = pageNumer ? pageNumer : this.page;
    this.http.getCustomerReportsApi(this.page,pageSize ).subscribe(res => {  
      this.loading = false;       
      this.customerReportList = res.responseObj.customerReport && res.responseObj.customerReport.length ? res.responseObj.customerReport : [];
      this.totalRecords = res.responseObj.count ? res.responseObj.count : 0;
    },
      error => {
        this.loading = false;       
      });

  }
  // To get date formate date(YYY-MM-DD)
  formatDate(strDate) {
    let dateStr:string = "N/A";
    if (strDate != null) {
      dateStr = this.util.formatDate(strDate);
    } 
    return dateStr;
  }
}



// WEBPACK FOOTER //
// ./src/app/customer-report/customer-report.component.ts